<template>
<div class="home-study-wrapper">
    <div class="x-banner-con" :style="{backgroundImage:'url('+ studyBanner+')'}"></div>
    <div class="menu-nav-con clearfix">
        <div class="nav-main-con">
            <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
            <span @click="toHome">首页</span>
            <span class="sp-nav-line">></span>
            <span>学习中心</span>
        </div>
    </div>
    <div class="study-list-con">
        <div class="file-source-con clearfix">
            <div class="fl x-intro-item jdx-intro-con">
                <div class="intro-head-con clearfix">
                    <span class="fl sp-label-title">酒店运营管理</span>
                </div>
                <div class="study-item-li clearfix" @click="toStudyCenter('jdx')">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>教学资源</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
                <div class="study-item-li clearfix">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>培训平台</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
                <div class="study-item-li clearfix">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>模拟考核系统</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
            </div>
            <div class="fl x-intro-item">
                <div class="intro-head-con clearfix">
                    <span class="fl sp-label-title">餐饮管理运行</span>
                </div>
                <div class="study-item-li clearfix" @click="toStudyCenter('cyx')">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>教学资源</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
                <div class="study-item-li clearfix">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>培训平台</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
                <div class="study-item-li clearfix">
                    <i class="kd-icon-xiangmu big-icon"></i>
                    <span>模拟考核系统</span>
                    <i class="kd-icon-xiangyou1 fr"></i>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            studyBanner: require('assets/images/home-study-img.png')
        }
    },
    created() {

    },
    methods: {
        toStudyCenter(type) {
            this.$router.push({
                name: 'studyCenter',
                params: {
                    xType: type
                }
            });
        },
        toHome() {
            this.$router.push({
                name: 'xHome'
            });
        }
    }
}
</script>

<style lang="scss">
.home-study-wrapper {
    .x-banner-con {
        height: 240px;
        background-size: cover;
        background-position: center top;
        background-repeat: no-repeat;
    }

    .menu-nav-con {
        background: #F5F0F0;

        .nav-main-con {
            margin: 0 auto;
            width: 1200px;
            height: 40px;
            line-height: 40px;
            color: #333333;
            font-size: 14px;
        }

        .sp-nav-line {
            margin: 0 6px;
        }
    }

    .study-list-con {
        margin: 30px auto;
        padding-bottom: 60px;
        width: 1200px;

        .x-intro-item {
            margin-top: 20px;
            width: 390px;
            height: 320px;
            background: #FFFFFF;
            border: 1px solid #999999;
            box-sizing: border-box;

            .intro-head-con {
                padding: 0 15px;
                height: 50px;
                background: #F0EBEB;
                line-height: 50px;
            }

            .sp-label-title {
                color: #05243D;
                font-size: 18px;
                font-weight: bold;
            }

            .sp-label-more {
                color: #333333;
                font-size: 14px;
                cursor: pointer;
            }

            .file-item-li {
                margin-top: 22px;
                padding: 0 10px;
                font-size: 14px;
                color: #333;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                cursor: pointer;
            }

            .file-item-li:hover {
                color: #05243D;
            }

            .study-item-li {
                margin: 0 25px;
                padding: 15px 0;
                font-weight: bold;
                font-size: 16px;
                border-bottom: 1px solid #333333;
                cursor: pointer;

                .big-icon {
                    font-size: 20px;
                    vertical-align: -1px;
                }

                a {
                    display: block;
                    color: #000;

                }
            }

            .study-item-li:hover {
                color: #05243D;
            }

            .link-way-item {
                margin: 25px 25px 0 25px;
                color: #333333;
            }
        }

        .jdx-intro-con {
            margin-right: 20px;
        }
    }
}

@media only screen and (max-width: 768px) {
    .home-study-wrapper {
        .x-banner-con {
            height: 90px;
        }

        .menu-nav-con {
            background: #F5F7FB;

            .nav-main-con {
                padding: 0 20px;
                width: 100%;
            }
        }

        .study-list-con {
            margin-top: 0;
            padding: 10px;
            width: 100%;
            background: #fff;
            box-sizing: border-box;

            .x-intro-item {
                float: none !important;
                margin: 20px 20px 0 20px;
                padding-bottom: 20px;
                width: auto;
                height: auto;
                background: #FFFFFF;
                border: 1px solid #999999;
                box-sizing: border-box;

                .intro-head-con {
                    padding: 0 10px;
                    height: 42px;
                    background: #F0EBEB;
                    line-height: 42px;
                }

                .sp-label-title {
                    color: #05243D;
                    font-size: 14px;
                    font-weight: bold;
                }

                .sp-label-more {
                    color: #333333;
                    font-size: 12px;
                    color: #000;
                    cursor: pointer;
                }

                .sp-label-more:hover {
                    color: #05243D;
                }

                .file-item-li {
                    margin-top: 10px;
                    padding: 0 10px;
                    font-size: 14px;
                    color: #333;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    cursor: pointer;
                }

                .file-item-li:hover {
                    color: #05243D;
                }

                .study-item-li {
                    margin: 0 15px;
                    padding: 10px 0;
                    font-weight: bold;
                    font-size: 14px;
                    border-bottom: 1px solid #333333;
                    cursor: pointer;

                    .big-icon {
                        font-size: 18px;
                        vertical-align: -1px;
                    }

                    a {
                        display: block;
                        color: #000;

                    }
                }

                .study-item-li:hover {
                    color: #05243D;
                }

                .link-way-item {
                    margin: 25px 25px 0 25px;
                    color: #333333;
                }
            }
        }
    }
}
</style>
